import IEmittedEvent from "./IEmittedEvent";
import { EVENT_TYPES } from "../types/EventTypes";

export default class EmittedEvent implements IEmittedEvent {
  val: any;
  name: EVENT_TYPES;
  constructor(name: EVENT_TYPES, data?: any) {
    this.val = data;
    this.name = name;
  }
}
